
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as GenerateIconComponent } from "./generate-icon.svg";

export const GenerateIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <GenerateIconComponent {...props} />;
};
